// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Offers/index.css
// module id = 1875
// module chunks = 0